import { cloneElement, useState } from "react";
import { PERMISSIONS } from "./permissionMaps";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const hasPermission = ({ permissions, scopes }) => {
  const scopesMap = {};
  scopes.forEach((scope) => {
    scopesMap[scope] = true;
  });

  return permissions.some((permission) => scopesMap[permission]);
};

export default function PermissionsGate({
  children,
  scopes = []
}) {

  const[permission,set_permission] = useState("VIEWER")
  useState( () => {
    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      "code": cookies.get("code"),
      "login" : cookies.get("login")
    })
    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_permission/" , options).then(response=>response.json())
    .then(async data=>{ 
      try{
        set_permission(data)
      }
      catch(error) {
      }
          
    });
  },[])

  const permissions = PERMISSIONS[permission];
  const permissionGranted = hasPermission({ permissions, scopes });
  if (!permissionGranted) return <></>

  return <>{children}</>;
}
